import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 600,
    },
}));
